// theirs

// ours
import classNames from 'classnames'
import { ContentDataModel } from '../../../interfaces'
import {
    appendLocationMultiple,
    appendLocationSingle,
    appendSizes,
} from '../../../utils/append-location'
import NextChapter from '../NextChapter'
import { photoGalleryBaseClass, StyledPhotoGallery } from './style'

export interface PhotoGalleryProps {
    className?: string
    testId?: string
    content: ContentDataModel
    animationControls?: any
    doesHaveNextChapter?: boolean
}

const PhotoGallery = ({
    className,
    testId,
    content,
    animationControls,
}: PhotoGalleryProps) => {
    const doesHaveNextChapter = typeof content.contentNextChapter === 'object'
    return (
        <StyledPhotoGallery
            className={classNames(photoGalleryBaseClass, className)}
            data-testid={testId}
            content={content}
            doesHaveNextChapter={doesHaveNextChapter}
        >
            <div className="content-outer">
                <div className="content-inner">
                    {content.contentPicture && (
                        <div className="image-wrapper">
                            {content.contentPicture.map((picture, index) => (
                                <picture
                                    key={index}
                                    className={picture.contentPictureClass}
                                    data-testid={picture.contentPictureTestId}
                                >
                                    <img
                                        src={appendLocationSingle(
                                            'images',
                                            picture.contentPictureImageSource
                                        )}
                                        alt={
                                            picture.contentPictureImageAlternateText
                                        }
                                        {...(picture.contentPictureSource && {
                                            srcSet: appendLocationMultiple(
                                                'images',
                                                picture.contentPictureSource
                                            ),
                                            sizes: appendSizes(
                                                picture.contentPictureSource
                                            ),
                                        })}
                                    />
                                    <span className="picture-text">
                                        {
                                            picture.contentPictureImageAlternateText
                                        }
                                    </span>
                                </picture>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            {content.contentNextChapter && (
                <NextChapter
                    content={content}
                    animationControls={animationControls}
                />
            )}
        </StyledPhotoGallery>
    )
}

export default PhotoGallery
